// Prevent any old, global input handler from also running
$(document).off('input', '.personalization_text');

// Keep this if you use it
function validateInput(input) {
  // keep A–Z, a–z, dot, and space only; then cap length
  input.value = input.value.replace(/[^A-Za-z. ]/g, '').slice(0, 10);

  // Update live character count
  const counter = document.querySelector('.left_total');
  if (counter) counter.textContent = input.value.length;
}
function classForChar(c){ return c === '.' ? 'dot' : c.toLowerCase(); }

// Tabs
$(document).on('click', '.pers_tab', function() {
  const tab = String($(this).data('tab') || '1');

  $('.pers_tab').removeClass('active').attr('aria-selected', false);
  $(this).addClass('active').attr('aria-selected', true);

  $('.custom_personalization_popup_top, .custom_personalization_popup_bottom')
    .hide().attr('hidden', true);

  $(`.custom_personalization_popup_top[data-tab="${tab}"], .custom_personalization_popup_bottom[data-tab="${tab}"]`)
    .show().removeAttr('hidden');
});

// Colors (scoped to its tab)
$(document).on('click', '.custom_personalization_color', function() {
  const $colorsMain = $(this).closest('.custom_personalization_colors_main');
  $colorsMain.find('.custom_personalization_color').removeClass('active');
  $(this).addClass('active');

  const label = $(this).attr('color_text') || $(this).attr('color') || '';
  $colorsMain.find('.custom_personalization_label_color strong').text(label);

  $(this).closest('.custom_personalization_popup_bottom').find('.personalization_text').trigger('input');
});

// Reset (scoped)
$(document).on('click', '.custom_personalization_reset', function() {
  const $bottom = $(this).closest('.custom_personalization_popup_bottom');
  $bottom.find('.personalization_text').val('').trigger('input');
});

// Input → render only into the matching TOP for this tab
// Make sure no older handlers conflict
$(document).off('input', '.personalization_text');

// Input → render only into the matching TOP for this tab
$(document).on('input', '.personalization_text', function () {
  const $input  = $(this);
  var raw     = $input.val() || '';
  const  raw2 =  $input.val() || '';
  const $bottom = $input.closest('.custom_personalization_popup_bottom');
  const tab     = String($bottom.data('tab') || '1');
   raw = raw.replace(/ /g, "$");
  // 1) Write to the correct upsell hidden field
  const $upsellWrap = $('.upsell_content_main_bottom_right');
  if (tab == '2') {
    $upsellWrap.find('input[name="upsell_product_alphabet2"]').val(raw2);
  } else {
    $upsellWrap.find('input[name="upsell_product_alphabet"]').val(raw2);
  }

  // 2) Combined check across BOTH tabs (treat spaces as characters just like your original code)
  const enc1 = ($('.custom_personalization_popup_bottom[data-tab="1"] .personalization_text').val() || '').replace(/ /g, '$');
  const enc2 = ($('.custom_personalization_popup_bottom[data-tab="2"] .personalization_text').val() || '').replace(/ /g, '$');
  const anyHasText = (enc1.length > 0 || enc2.length > 0);

  // Toggle global upsell container
  const $upsellMain = $('.upsell_content_main');
  if (anyHasText) {
    $upsellMain.addClass('active');
  } else {
    $upsellMain.removeClass('active');
  }

  // 3) Enable/disable buttons PER TAB (own input length)
  function toggleButtonsFor(tabNum) {
    const $b = $(`.custom_personalization_popup_bottom[data-tab="${tabNum}"]`);
    const encoded = ($b.find('.personalization_text').val() || '').replace(/ /g, '$');
    const $btns = $b.find('.custom_personalization_trigger_buy, .custom_personalization_reset');
    if (encoded.length) $btns.removeAttr('disabled');
    else $btns.attr('disabled', 'disabled');
  }
  toggleButtonsFor('1');
  toggleButtonsFor('2');

  // 4) Render preview ONLY for the current tab
  const activeColor = ($bottom.find('.custom_personalization_color.active').attr('color') || 'Transparent').toLowerCase();
  const $target = $(`.custom_personalization_popup_top[data-tab="${tab}"] .custom_texts[data-tab="${tab}"]`);
  $target.empty();

  for (let i = 0; i < raw.length; i++) {
    const ch = raw[i];
    if (ch === ' ') continue; // skip spaces in preview
    $(`<div class="text_${classForChar(ch)} color_${activeColor}"></div>`).appendTo($target);
  }
}); 


// Open / close (unchanged)
$(document).on('click', '.custom_personalication_button', function(){ $('.custom_personalization_popup').show().addClass('active'); });
$(document).on('click', '.custom_personalization_popup_bg,.close_personalization', function(){
  $('.custom_personalization_popup').removeClass('active');
  setTimeout(()=>$('.custom_personalization_popup').hide(), 600);
});

// Guard (unchanged)
$(document).on('click', '.upsell_content_main:not(.active) .css_selector_upsell', function(){
  $('.custom_personalication_button').trigger('click');
});


$(document).on("click", '.custom_personalization_trigger_buy:not([disabled])', function(e) {  
$('button#AddToCart').trigger('click');
$('.custom_personalization_popup_bg').trigger('click');
});
 